import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "show" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", null, "You're being redirected", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: this.url
      }, "Click here!", 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createElementVNode("p", null, "If it takes too long", -1))
    ])
  ]))
}